import { useFilterContext } from './FilterContext';

export const useFilterGroup = (id: string, collapsibleGroup = true) => {
    const { expandedFilterGroups, setExpandedFilterGroups } = useFilterContext();

    const toggleGroup = () => {
        if (expandedFilterGroups.includes(id)) {
            setExpandedFilterGroups(expandedFilterGroups.filter(item => item !== id));
        } else {
            setExpandedFilterGroups([...expandedFilterGroups, id]);
        }
    };

    return {
        expanded: collapsibleGroup ? expandedFilterGroups.includes(id) : true,
        toggleGroup
    };
};
